module.exports = [
	{
		"id": 4,
		"question": "Co je Stužák?",
		"answer": "Projekt Stužák (Studenti žákům) je série vzdělávacích workshopů a her, které vytvořili a nyní realizují studenti vysokých škol rozličných oborů humanitního zaměření, které mají za cíl doplnit výuku na středních školách a zároveň zvýšit zájem žáků o různá témata z veřejného života."
	},
	{
		"id": 1,
		"question": "Co vlastně workshopy (hry) jsou, o čem jsou a pro koho jsou?",
		"answer": "Jedná se o 90minutové bloky výuky, které jsou pojaty hravou formou (simulace, role-playing) a vyučovány studenty daných oborů. Snažíme se pokrýt rozličná témata společenskovědních předmětů. Vyučujeme žáky středních škol. Výuku je možné upravit pro všechny ročníky."
	},
	{
		"id": 2,
		"question": "Má workshop i nějaký jiný význam, než že si žáci budou “pouze hrát”?",
		"answer": "Hravá forma je kombinována s teorií. To znamená, že cílem je se něco dozvědět, ale takovým způsobem, který žáky namotivuje k dalšímu zájmu o daná témata."
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/browser/Feature/components/faq/questions.json
// module id = 1249
// module chunks = 0